import * as React from 'react';

// PACKAGES
import { Link, useHistory } from 'react-router-dom';

// COMPONENTS
import Button from './Button';
import DisplayDate from './DisplayDate';
import StatusIcon from './StatusIcon';

// ICONS
import { ReactComponent as PlusIcon } from '../assets/svg/plus.svg';

// TYPES
import { StaffFetchPolicy } from '../api/models/staff-fetch-policy';
import { useAppDispatch, useAppSelector } from '../store';
import UserSlice from '../store/slices/User';

interface ProfilePoliciesTypes {
	policies?: Array<StaffFetchPolicy>;
	defaultMaxItems?: number;
	isPastProfile?: boolean;
}

const ProfilePolicies: React.FC<ProfilePoliciesTypes> = ({ policies, defaultMaxItems, isPastProfile }) => {
	const [maxPolicyItem, setMaxPolicyItem] = React.useState<number>(defaultMaxItems || 5);

	const dispatch = useAppDispatch();
	const history = useHistory();

	const isOrganisationAdmin = useAppSelector((state) => state.user.isOrganisationAdmin);

	const goToPolicies = () => {
		if (isOrganisationAdmin) {
			dispatch(UserSlice.actions.update({ viewPoliciesAsAdmin: false }));
		}

		history.push('/policies');
	};

	return (
		<>
			{policies && policies.length > 0 && (
				<section className="info-section">
					<div className="section-header">
						<h2 className="header-name color-dark">Policies</h2>
					</div>

					{policies.slice(0, maxPolicyItem).map((item, index) => {
						return (
							<div key={index} className="row-container">
								<div className="row detail-row">
									<div className="col-auto pdl-0 pdr-0">
										<StatusIcon statusType={item.status || 'Error'} />
									</div>

									<div className="col-md-auto full-width">
										<div className="row detail-info">
											<div className="col-lg-3 detail-name">{item.title}</div>

											<div className={`col-lg-2 detail-label ${item.status?.toLowerCase()}`}>
												{item.policyAcknowledgementStatus}
											</div>

											<div className="col-lg-4 detail-status">
												<div className="title">Last updated</div>

												<time className="name">
													<DisplayDate>{item.updated}</DisplayDate>
												</time>
											</div>

											<div className="col-lg-3 detail-status">
												<div className="title">By</div>
												<div className="status">{item.creator}</div>
											</div>
										</div>
									</div>

									<div className="col-auto pdr-0 link-group">
										{item.status === 'Success' || isPastProfile ? (
											<Button className="btn-text pdr-0" onClick={goToPolicies}>
												View
											</Button>
										) : (
											<Button className="btn-text pdr-0" onClick={goToPolicies}>
												Review
											</Button>
										)}
									</div>
								</div>
							</div>
						);
					})}

					{maxPolicyItem < policies.length && (
						<Button
							className="btn-secondary btn-show-more"
							onClick={() => setMaxPolicyItem(policies.length)}
							buttonIcon={<PlusIcon className="link-icon" />}
						>
							Show {policies.length - maxPolicyItem} more
						</Button>
					)}
				</section>
			)}
		</>
	);
};

export default ProfilePolicies;
